
import { Controller } from "stimulus";
import {
  sendDataToParent,
  emitCloseWidget
} from "helpers";
 
export default class extends Controller {
  static targets=["dropzone"];

  connect() {
    this.files = []
  }

  get dropzoneController() {
    return this.application.getControllerForElementAndIdentifier(this.dropzoneTarget, "dropzone")
  }

  removeFiles(){
    // Remove files from drozpone 
    this.dropzoneController.dropZone.removeAllFiles()
  }

  close() {
    // compare this.files (ground truth) with this.dropzoneController.dropZone.getAcceptedFiles()
    const currentViewableFiles = this.dropzoneController.dropZone.getAcceptedFiles()
    // Get all files that are in the accepted array but not in the 'saved files' list. These are files the user added then closed the window without clicking 'add'
    const notSavedFiles = currentViewableFiles.filter((file) => !this.files.includes(file))
    notSavedFiles.forEach(file => {
      this.dropzoneController.dropZone.removeFile(file)
    })

    const missingFiles = this.files.filter((file) => !currentViewableFiles.includes(file))
    missingFiles.forEach(file => {
      this.dropzoneController.dropZone.addFile(file)
    })
    emitCloseWidget(this.dropzoneController.dropzoneId, this.files.length)
  }

  setFiles(files) {
    this.files = files
  }

  addFiles(){
    let filesAdded = this.dropzoneController.dropZone.getAcceptedFiles()
    this.setFiles(filesAdded)

    const fileDetails = filesAdded.map(function(file){
      return {
        cdnUrl: file.cdnUrl,
        name: file.name, 
        size: file.size,
        type: file.type,
      }
    });
    sendDataToParent(fileDetails, this.dropzoneController.dropzoneId, null, true)
  }
}